import { ConfigReportComboApi } from "go-report-combo/User/services/types";
import { REPORT_dayofweek_two_group_organizations } from "./CatalogReports/REPORT_dayofweek_two_group_organizations";
import { REPORT_weeks_food_bar_with_last_week_and_year_variables } from "./CatalogReports/REPORT_weeks_food_bar_with_last_week_and_year_variables";

const catalogTemplates = [
	REPORT_weeks_food_bar_with_last_week_and_year_variables,
	REPORT_dayofweek_two_group_organizations,
] as ConfigReportComboApi[];

export const CATALOG_TEMPLATE_LIST = catalogTemplates;
